export type ModernFamilyProofStage =
  | 'relationship_selected'
  | 'connector_candidates'
  | 'connector_selected'
  | 'parent_ids_computed'
  | 'db_write_started'
  | 'db_write_finished'
  | 'db_readback_started'
  | 'db_readback_finished'
  | 'renderer_input'
  | 'runtime_mismatch';

export type ModernFamilyRuntimeProof = {
  id: string;
  ts: string;
  stage: ModernFamilyProofStage;
  relationship?: string | null;
  customLabel?: string | null;
  viewerMemberId?: string | null;
  connectorId?: string | null;
  secondConnectorId?: string | null;
  parentIds?: string[];
  candidateCount?: number;
  ok?: boolean;
  detail?: string;
  payload?: unknown;
};

const KEY = 'kinscircle.modernFamily.runtimeProof.v1';

export function emitModernFamilyRuntimeProof(input: Omit<ModernFamilyRuntimeProof, 'id' | 'ts'>) {
  const proof: ModernFamilyRuntimeProof = {
    id: `proof-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    ts: new Date().toISOString(),
    ...input,
  };

  try {
    const existing = JSON.parse(localStorage.getItem(KEY) || '[]');
    const next = [proof, ...existing].slice(0, 250);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}

  try {
    window.dispatchEvent(new CustomEvent('kinscircle:modern-family-runtime-proof', { detail: proof }));
  } catch {}

  try {
    console.info('[ModernFamilyRuntimeProof]', proof.stage, proof);
  } catch {}

  return proof;
}

export function getModernFamilyRuntimeProof(): ModernFamilyRuntimeProof[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}
